import { ActivatedRouteSnapshot } from '@angular/router';

import { Alert } from './alerts';
import { AlertService } from './alerts.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class AlertResolver {
  constructor(private alertService: AlertService) {}

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  resolve(route: ActivatedRouteSnapshot): Observable<Alert[] | null> {
    return this.alertService.getAlerts();
  }
}
